export enum UiButtonTag {
  BUTTON = 'button',
  A = 'a',
  ROUTER_LINK = 'RouterLink',
}
export enum UiButtonType {
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset',
}

export enum UiButtonTarget {
  BLANK = '_blank',
  PARENT = '_parent',
  SELF = '_self',
  TOP = '_top',
}

export enum UiButtonTheme {
  LIGHT_BLUE = 'light_blue',
  RED = 'red',
  NAVY = 'navy',
  WHITE = 'white',
  GOLDEN = 'golden',
}
